const demoRequests = {
  listDemoRequests: {
    list: "Demo Requests",
    searchPlaceholder: "Search Company name",
    fromDate: "From",
    toDate: "To",
    details: "Details",
    name: "Name",
    workEmail: "Work Email",
    phoneNumber: "Phone Number",
    companyName: "Company Name",
    dateRequested: "Date Requested",
    contacted: "Contacted",
    actions: "Actions",
    delete: "Delete",
    remove: "Remove",
    removeTitle: "Remove this demo request?",
    removeDescription:
      "This will permanently remove {name}'s request from the list. This action can't be undone.",
    removeAction: "Remove Request",
    removedToastTitle: "Request removed",
    removedToastBody: "{name}'s demo request was removed from the list.",
    expand: "Expand",
    collapse: "Collapse",
    requestDetailsLabel: "Request Details:",
    showingRange: "Showing {from}-{to} of {total} requests",
    noDataDescription: "Sorry, No demo requests found.",
    bannerNoteLabel: "Note:",
    bannerNote:
      "These are demo requests from the landing page. Contact these prospects offline using their provided contact information. No actions are required in this interface.",
  },
};

export default demoRequests;
